var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardUsuario',{staticClass:"item"}),_c('FormularioAlterarSenha',{staticClass:"item"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }